const configScript = document.getElementById('js-variables');
/**
 * @type {{
 *     GOOGLE_MAPS_API_KEY: string,
 *     GOOGLE_MAPS_STORE_MAP_ID: string,
 *     cartCount: number,
 * }}
 */
let config = {};
if (configScript) {
    config = JSON.parse(configScript.innerText);
}

const {GOOGLE_MAPS_API_KEY, GOOGLE_MAPS_STORE_MAP_ID, cartCount} = config;

export {
    GOOGLE_MAPS_API_KEY,
    GOOGLE_MAPS_STORE_MAP_ID,
    cartCount,
};
export default config;
